"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useIsScrolling = topValue => {
  const [isScrolling, setIsScrolling] = (0, _react.useState)(false);
  const targetValue = topValue ? topValue : 0;
  (0, _react.useEffect)(() => {
    const onScroll = () => setIsScrolling(window.pageYOffset > targetValue);
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, [targetValue]);
  return isScrolling;
};
var _default = exports.default = useIsScrolling;